import { useEffect } from "react";
import { useApp } from "../../hooks/useApp";

const TYPE_CONFIG = {
  success: { icon: "✅", cls: "bg-green-50 text-green-700 border-green-200" },
  error:   { icon: "⛔", cls: "bg-red-50 text-red-700 border-red-200" },
  warning: { icon: "⚠️", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  info:    { icon: "📋", cls: "bg-blue-50 text-blue-700 border-blue-200" },
};

function Toast({ toast, onRemove }) {
  useEffect(() => {
    const t = setTimeout(() => onRemove(toast.id), 4000);
    return () => clearTimeout(t);
  }, [toast.id, onRemove]);

  const { icon, cls } = TYPE_CONFIG[toast.type] ?? TYPE_CONFIG.success;

  return (
    <div className={`flex items-center gap-2 px-5 py-2.5 rounded-full shadow-lg text-sm font-medium border ${cls}`}>
      <span>{icon}</span>
      <span className="whitespace-nowrap">{toast.message}</span>
      <button
        onClick={() => onRemove(toast.id)}
        className="ml-2 opacity-60 hover:opacity-100 transition-opacity"
      >
        ✕
      </button>
    </div>
  );
}

export default function Toaster() {
  const { toasts, removeToast } = useApp();
  if (!toasts.length) return null;
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] flex flex-col items-center gap-2">
      {toasts.map((t) => (
        <Toast key={t.id} toast={t} onRemove={removeToast} />
      ))}
    </div>
  );
}
